module.exports = __webpack_public_path__ + "static/img/amp.1334005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amp.png
// module id = 288
// module chunks = 0